import React from "react";
import { useTranslation } from 'react-i18next';

/**
 * Combination of UIKit Article tile that is made clickable, which would open a full-screen modal with more in-depth info
 * @param {*} props 
 * @returns 
 */
function ArticleWithModal(props) {

    var { t, i18n } = useTranslation();

    function handleOpenModal(event) {
        event.preventDefault();
        window.UIkit.modal("#" + props.modalName).show();
    }

    return (
        <>
            <article>
                {/* Clickable Article Tile that acts as Trigger */}
                <div onClick={handleOpenModal} className="uk-card uk-card-default uk-card-hover uk-border-rounded uk-box-shadow-small">
                    <div className="uk-card-media-top">
                        <img src={props.Image} alt={props.ImageDescription} />
                    </div>
                    <div className="uk-card-body">
                        <h3 className="uk-card-title" style={{ color: "#000000" }}>
                            {t(props.ArticleTitle)}
                        </h3>
                        <p>
                            {t(props.Paragraph1)}
                        </p>
                    </div>
                </div>
            </article>

            {/* Modal (invisible until triggered) */}
            <div id={props.modalName} className="uk-modal-full" uk-modal="true">
                <div className="uk-modal-dialog">
                    <button className="uk-modal-close-full uk-close-large" type="button" uk-close="true"></button>

                    <div className="uk-grid-collapse uk-child-width-1-2@s uk-flex-middle" uk-grid="true">
                        <div
                            className="uk-background-cover"
                            style={{ backgroundImage: `url('${props.Image}')` }}
                            uk-height-viewport="true">
                        </div>

                        <div className="uk-padding-large">
                            <h1 style={{ color: "black !important" }}>{t(props.ArticleTitle)}</h1>
                            <p>
                                {t(props.Paragraph1)}
                            </p>
                            <p>
                                {t(props.Paragraph2)}
                            </p>
                            <p>
                                {t(props.Paragraph3)}
                            </p>
                            <p>
                                {t(props.Paragraph4)}
                            </p>
                            <p>
                                {t(props.Paragraph5)}
                            </p>

                            <a
                                href="/apply-visa"
                                className="uk-button uk-button-jai uk-button-large uk-margin-top">
                                {t("infopages.landing.cta1")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ArticleWithModal;